import types from './types'

export const googleDriveAuthenticate = (callback) => ({ type: types.GOOGLE_DRIVE_AUTHENTICATE, callback })
export const googleDriveAuthenticateCallback = () => ({ type: types.GOOGLE_DRIVE_AUTHENTICATE_CALLBACK })

export const googleDriveCheckAuth = () => ({ type: types.GOOGLE_DRIVE_CHECK_AUTH_ATTEMPT })
export const googleDriveCheckAuthSuccess = () => ({ type: types.GOOGLE_DRIVE_CHECK_AUTH_SUCCESS })
export const googleDriveCheckAuthFailure = () => ({ type: types.GOOGLE_DRIVE_CHECK_AUTH_FAILURE})

export const googleDriveDeauthenticate = () => ({ type: types.GOOGLE_DRIVE_DEAUTH_ATTEMPT })
export const googleDriveDeauthenticateSuccess = () => ({ type: types.GOOGLE_DRIVE_DEAUTH_SUCCESS })
export const googleDriveDeauthenticateFailure = () => ({ type: types.GOOGLE_DRIVE_DEAUTH_FAILURE})

export const googleDriveSetBase = (folderId) => ({ type: types.GOOGLE_DRIVE_SET_BASE_ATTEMPT, folderId })
export const googleDriveSetBaseSuccess = () => ({ type: types.GOOGLE_DRIVE_SET_BASE_SUCCESS })
export const googleDriveSetBaseFailure = () => ({ type: types.GOOGLE_DRIVE_SET_BASE_FAILURE})

export const xeroAuthenticate = (callback) => ({ type: types.XERO_AUTHENTICATE, callback })
export const xeroAuthenticateComplete = () => ({ type: types.XERO_AUTHENTICATE_COMPLETE })

export const xeroStatus = () => ({ type: types.XERO_STATUS_ATTEMPT })
export const xeroStatusFailure = () => ({ type: types.XERO_STATUS_FAILURE})
export const xeroStatusSuccess = (data) => ({ type: types.XERO_STATUS_SUCCESS, data})

export const xeroDisable = () => ({ type: types.XERO_DISABLE_ATTEMPT })
export const xeroDisableFailure = () => ({ type: types.XERO_DISABLE_FAILURE})
export const xeroDisableSuccess = () => ({ type: types.XERO_DISABLE_SUCCESS})

export const xeroEnabled = () => ({ type: types.XERO_ENABLED_ATTEMPT })
export const xeroEnabledFailure = () => ({ type: types.XERO_ENABLED_FAILURE})
export const xeroEnabledSuccess = (status) => ({ type: types.XERO_ENABLED_SUCCESS, status})

export const xeroUpdateAccountData = () => ({ type: types.XERO_UPDATE_ACCOUNT_DATA_ATTEMPT })
export const xeroUpdateAccountDataSuccess = (data) => ({ type: types.XERO_UPDATE_ACCOUNT_DATA_SUCCESS, data })
export const xeroUpdateAccountDataFailure = (message, code) => ({ type: types.XERO_UPDATE_ACCOUNT_DATA_FAILURE, message, code })

export const zohoStatus = (connectIfAuthorised = false) => ({ type: types.ZOHO_STATUS_ATTEMPT, connectIfAuthorised })
export const zohoStatusFailure = (message, code) => ({ type: types.ZOHO_STATUS_FAILURE, message, code })
export const zohoStatusSuccess = (status) => ({ type: types.ZOHO_STATUS_SUCCESS, status})

export const zohoConnectStart = (step) => ({ type: types.ZOHO_CONNECT_START, step })
export const zohoConnectCancel = () => ({ type: types.ZOHO_CONNECT_CANCEL })
export const zohoSetConnectStep = (step) => ({ type: types.ZOHO_SET_CONNECT_STEP, step })

export const zohoAuthenticate = (email, region) => ({ type: types.ZOHO_AUTHENTICATE_ATTEMPT, email, region })
export const zohoAuthenticateFailure = (message, code) => ({ type: types.ZOHO_AUTHENTICATE_FAILURE, message, code })
export const zohoAuthenticateSuccess = (status) => ({ type: types.ZOHO_AUTHENTICATE_SUCCESS, status})

export const zohoInitializeWorkspace = () => ({ type: types.ZOHO_INITIALIZE_WORKSPACE })

export const zohoActivate = (organisationId, workspaceId, workspace, range, tables) => ({ type: types.ZOHO_ACTIVATE_ATTEMPT, organisationId, workspaceId, workspace, range, tables })
export const zohoActivateFailure = (message, code) => ({ type: types.ZOHO_ACTIVATE_FAILURE, message, code })
export const zohoActivateSuccess = (status) => ({ type: types.ZOHO_ACTIVATE_SUCCESS, status})

export const zohoDeactivate = () => ({ type: types.ZOHO_DEACTIVATE_ATTEMPT })
export const zohoDeactivateFailure = (message, code) => ({ type: types.ZOHO_DEACTIVATE_FAILURE, message, code })
export const zohoDeactivateSuccess = (status) => ({ type: types.ZOHO_DEACTIVATE_SUCCESS, status})

export const zohoGetOrganisations = () => ({ type: types.ZOHO_GET_ORGANISATIONS_ATTEMPT })
export const zohoGetOrganisationsFailure = (message, code) => ({ type: types.ZOHO_GET_ORGANISATIONS_FAILURE, message, code })
export const zohoGetOrganisationsSuccess = (organisations) => ({ type: types.ZOHO_GET_ORGANISATIONS_SUCCESS, organisations})

export const zohoGetWorkspaces = () => ({ type: types.ZOHO_GET_WORKSPACES_ATTEMPT })
export const zohoGetWorkspacesFailure = (message, code) => ({ type: types.ZOHO_GET_WORKSPACES_FAILURE, message, code })
export const zohoGetWorkspacesSuccess = (workspaces) => ({ type: types.ZOHO_GET_WORKSPACES_SUCCESS, workspaces})

export const zohoGetRecords = (range, tables) => ({ type: types.ZOHO_GET_RECORDS_ATTEMPT, range, tables })
export const zohoGetRecordsFailure = (message, code) => ({ type: types.ZOHO_GET_RECORDS_FAILURE, message, code })
export const zohoGetRecordsSuccess = (records) => ({ type: types.ZOHO_GET_RECORDS_SUCCESS, records})

export const zohoGetPlan = () => ({ type: types.ZOHO_GET_PLAN_ATTEMPT })
export const zohoGetPlanFailure = (message, code) => ({ type: types.ZOHO_GET_PLAN_FAILURE, message, code })
export const zohoGetPlanSuccess = (plan) => ({ type: types.ZOHO_GET_PLAN_SUCCESS, plan })

export const zohoGetSelectedTables = () => ({ type: types.ZOHO_GET_SELECTED_TABLES_ATTEMPT })
export const zohoGetSelectedTablesFailure = (message, code) => ({ type: types.ZOHO_GET_SELECTED_TABLES_FAILURE, message, code })
export const zohoGetSelectedTablesSuccess = (tables) => ({ type: types.ZOHO_GET_SELECTED_TABLES_SUCCESS, tables })

export const zohoReauthoriseStart = () => ({ type: types.ZOHO_REAUTHORISE_START })
export const zohoReauthoriseCancel = () => ({ type: types.ZOHO_REAUTHORISE_CANCEL })

export const zohoSetOrganisationId = (organisationId) => ({ type: types.ZOHO_SET_ORGANISATION_ID, organisationId })
export const zohoSetWorkspaceId = (workspaceId) => ({ type: types.ZOHO_SET_WORKSPACE_ID, workspaceId })

export const zohoChangeRangeStart = () => ({ type: types.ZOHO_CHANGE_RANGE_START })
export const zohoChangeRangeCancel = () => ({ type: types.ZOHO_CHANGE_RANGE_CANCEL })

export const zohoUpdateSync = (range, tables) => ({ type: types.ZOHO_SYNC_UPDATE_ATTEMPT, range, tables })
export const zohoUpdateSyncFailure = (message, code) => ({ type: types.ZOHO_SYNC_UPDATE_FAILURE, message, code })
export const zohoUpdateSyncSuccess = (status) => ({ type: types.ZOHO_SYNC_UPDATE_SUCCESS, status})

export const quickBooksAuthenticate = (callback) => ({ type: types.QUICK_BOOKS_AUTHENTICATE, callback })
export const quickBooksAuthenticateComplete = () => ({ type: types.QUICK_BOOKS_AUTHENTICATE_COMPLETE })

export const quickBooksEnabled = () => ({ type: types.QUICK_BOOKS_ENABLED_ATTEMPT })
export const quickBooksEnabledSuccess = (status) => ({ type: types.QUICK_BOOKS_ENABLED_SUCCESS, status})
export const quickBooksEnabledFailure = (message, code) => ({ type: types.QUICK_BOOKS_ENABLED_FAILURE, message, code})

export const quickBooksDisable = () => ({ type: types.QUICK_BOOKS_DISABLE_ATTEMPT })
export const quickBooksDisableSuccess = () => ({ type: types.QUICK_BOOKS_DISABLE_SUCCESS})
export const quickBooksDisableFailure = (message, code) => ({ type: types.QUICK_BOOKS_DISABLE_FAILURE, message, code})

export const quickBooksStatus = () => ({ type: types.QUICK_BOOKS_STATUS_ATTEMPT })
export const quickBooksStatusSuccess = (data) => ({ type: types.QUICK_BOOKS_STATUS_SUCCESS, data })
export const quickBooksStatusFailure = (message, code) => ({ type: types.QUICK_BOOKS_STATUS_FAILURE, message, code })

export const quickBooksUpdateAccountData = () => ({ type: types.QUICK_BOOKS_UPDATE_ACCOUNT_DATA_ATTEMPT })
export const quickBooksUpdateAccountDataSuccess = (data) => ({ type: types.QUICK_BOOKS_UPDATE_ACCOUNT_DATA_SUCCESS, data })
export const quickBooksUpdateAccountDataFailure = (message, code) => ({ type: types.QUICK_BOOKS_UPDATE_ACCOUNT_DATA_FAILURE, message, code })

export const shopifyAuthenticate = (shop) => ({ type: types.SHOPIFY_AUTHENTICATE, shop })
export const shopifyAuthenticateComplete = () => ({ type: types.SHOPIFY_AUTHENTICATE_COMPLETE })

export const shopifyEnabled = () => ({ type: types.SHOPIFY_ENABLED_ATTEMPT })
export const shopifyEnabledSuccess = (data) => ({ type: types.SHOPIFY_ENABLED_SUCCESS, data})
export const shopifyEnabledFailure = (message, code) => ({ type: types.SHOPIFY_ENABLED_FAILURE, message, code})

export const shopifyDisable = () => ({ type: types.SHOPIFY_DISABLE_ATTEMPT })
export const shopifyDisableSuccess = (data) => ({ type: types.SHOPIFY_DISABLE_SUCCESS, data})
export const shopifyDisableFailure = (message, code) => ({ type: types.SHOPIFY_DISABLE_FAILURE, message, code})

export const shopifyStatus = () => ({ type: types.SHOPIFY_STATUS_ATTEMPT })
export const shopifyStatusSuccess = (data) => ({ type: types.SHOPIFY_STATUS_SUCCESS, data })
export const shopifyStatusFailure = (message, code) => ({ type: types.SHOPIFY_STATUS_FAILURE, message, code })

export const mailchimpAuthenticate = (callback) => ({ type: types.MAILCHIMP_AUTHENTICATE, callback })
export const mailchimpAuthenticateComplete = () => ({ type: types.MAILCHIMP_AUTHENTICATE_COMPLETE })

export const mailchimpEnabled = () => ({ type: types.MAILCHIMP_ENABLED_ATTEMPT })
export const mailchimpEnabledSuccess = (data) => ({ type: types.MAILCHIMP_ENABLED_SUCCESS, data})
export const mailchimpEnabledFailure = (message, code) => ({ type: types.MAILCHIMP_ENABLED_FAILURE, message, code})

export const mailchimpDisable = () => ({ type: types.MAILCHIMP_DISABLE_ATTEMPT })
export const mailchimpDisableSuccess = (data) => ({ type: types.MAILCHIMP_DISABLE_SUCCESS, data})
export const mailchimpDisableFailure = (message, code) => ({ type: types.MAILCHIMP_DISABLE_FAILURE, message, code})

export const mailchimpStatus = () => ({ type: types.MAILCHIMP_STATUS_ATTEMPT })
export const mailchimpStatusSuccess = (data) => ({ type: types.MAILCHIMP_STATUS_SUCCESS, data })
export const mailchimpStatusFailure = (message, code) => ({ type: types.MAILCHIMP_STATUS_FAILURE, message, code })

export const loadMailchimpLists = () => ({ type: types.MAILCHIMP_LOAD_LISTS_ATTEMPT })
export const loadMailchimpListsSuccess = (data) => ({ type: types.MAILCHIMP_LOAD_LISTS_SUCCESS, data })
export const loadMailchimpListsFailure = (message, code) => ({ type: types.MAILCHIMP_LOAD_LISTS_FAILURE, message, code })

export const loadMailchimpMergeFields = (listId) => ({ type: types.MAILCHIMP_LOAD_MERGE_FIELDS_ATTEMPT, listId})
export const loadMailchimpMergeFieldsSuccess = (data) => ({ type: types.MAILCHIMP_LOAD_MERGE_FIELDS_SUCCESS, data })
export const loadMailchimpMergeFieldsFailure = (message, code) => ({ type: types.MAILCHIMP_LOAD_MERGE_FIELDS_FAILURE, message, code })

export const hubspotAuthenticate = (callback) => ({ type: types.HUBSPOT_AUTHENTICATE, callback})
export const hubspotAuthenticateComplete = () => ({ type: types.HUBSPOT_AUTHENTICATE_COMPLETE })

export const hubspotEnabled = () => ({ type: types.HUBSPOT_ENABLED_ATTEMPT })
export const hubspotEnabledSuccess = (data) => ({ type: types.HUBSPOT_ENABLED_SUCCESS, data })
export const hubspotEnabledFailure = (message, code) => ({ type: types.HUBSPOT_ENABLED_FAILURE, message, code })

export const hubspotDisable = () => ({ type: types.HUBSPOT_DISABLE_ATTEMPT })
export const hubspotDisableSuccess = (data) => ({ type: types.HUBSPOT_DISABLE_SUCCESS, data })
export const hubspotDisableFailure = (message, code) => ({ type: types.HUBSPOT_DISABLE_FAILURE, message, code })

export const hubspotStatus = () => ({ type: types.HUBSPOT_STATUS_ATTEMPT })
export const hubspotStatusSuccess = (data) => ({ type: types.HUBSPOT_STATUS_SUCCESS, data })
export const hubspotStatusFailure = (message, code) => ({ type: types.HUBSPOT_STATUS_FAILURE, message, code })

export const loadHubspotLists = () => ({ type: types.HUBSPOT_LOAD_LISTS_ATTEMPT })
export const loadHubspotListsSuccess = (data) => ({ type: types.HUBSPOT_LOAD_LISTS_SUCCESS, data })
export const loadHubspotListsFailure = (message, code) => ({ type: types.HUBSPOT_LOAD_LISTS_FAILURE, message, code })

export const loadHubspotContactProperties = () => ({ type: types.HUBSPOT_LOAD_CONTACT_PROPERTIES_ATTEMPT })
export const loadHubspotContactPropertiesSuccess = (data) => ({ type: types.HUBSPOT_LOAD_CONTACT_PROPERTIES_SUCCESS, data })
export const loadHubspotContactPropertiesFailure = (message, code) => ({ type: types.HUBSPOT_LOAD_CONTACT_PROPERTIES_FAILURE, message, code })

export const hubspotUpdateData = () => ({ type: types.HUBSPOT_UPDATE_DATA_ATTEMPT })
export const hubspotUpdateDataSuccess = (data) => ({ type: types.HUBSPOT_UPDATE_DATA_SUCCESS, data })
export const hubspotUpdateDataFailure = (message, code) => ({ type: types.HUBSPOT_UPDATE_DATA_FAILURE, message, code })

export const oneDriveAuthenticate = (callback) => ({ type: types.ONE_DRIVE_AUTHENTICATE, callback })
export const oneDriveAuthenticateComplete = () => ({ type: types.ONE_DRIVE_AUTHENTICATE_COMPLETE })

export const oneDriveDisable = () => ({ type: types.ONE_DRIVE_DISABLE_ATTEMPT })
export const oneDriveDisableSuccess = (data) => ({ type: types.ONE_DRIVE_DISABLE_SUCCESS, data})
export const oneDriveDisableFailure = (message, code) => ({ type: types.ONE_DRIVE_DISABLE_FAILURE, message, code})

export const oneDriveStatus = () => ({ type: types.ONE_DRIVE_STATUS_ATTEMPT })
export const oneDriveStatusSuccess = (data) => ({ type: types.ONE_DRIVE_STATUS_SUCCESS, data })
export const oneDriveStatusFailure = (message, code) => ({ type: types.ONE_DRIVE_STATUS_FAILURE, message, code })

export const sharePointAuthenticate = (callback) => ({ type: types.SHARE_POINT_AUTHENTICATE, callback })

export const sharePointDisable = () => ({ type: types.SHARE_POINT_DISABLE_ATTEMPT })
export const sharePointDisableSuccess = (data) => ({ type: types.SHARE_POINT_DISABLE_SUCCESS, data})
export const sharePointDisableFailure = (message, code) => ({ type: types.SHARE_POINT_DISABLE_FAILURE, message, code})

export const sharePointStatus = () => ({ type: types.SHARE_POINT_STATUS_ATTEMPT })
export const sharePointStatusSuccess = (data) => ({ type: types.SHARE_POINT_STATUS_SUCCESS, data })
export const sharePointStatusFailure = (message, code) => ({ type: types.SHARE_POINT_STATUS_FAILURE, message, code })

export const loadSites = (search) => ({ type: types.DOCUMENTS_LOAD_SITES_ATTEMPT, search })
export const loadSitesSuccess = (data) => ({ type: types.DOCUMENTS_LOAD_SITES_SUCCESS, data })
export const loadSitesFailure = (message, code) => ({ type: types.DOCUMENTS_LOAD_SITES_FAILURE, message, code })

export const loadBaseSite = () => ({ type: types.DOCUMENTS_LOAD_BASE_SITE_ATTEMPT })
export const loadBaseSiteSuccess = (data) => ({ type: types.DOCUMENTS_LOAD_BASE_SITE_SUCCESS, data })
export const loadBaseSiteFailure = (message, code) => ({ type: types.DOCUMENTS_LOAD_BASE_SITE_FAILURE, message, code })

export const updateBaseSite = (id) => ({ type: types.DOCUMENTS_UPDATE_BASE_SITE_ATTEMPT, id })
export const updateBaseSiteSuccess = (data) => ({ type: types.DOCUMENTS_UPDATE_BASE_SITE_SUCCESS, data })
export const updateBaseSiteFailure = (message, code) => ({ type: types.DOCUMENTS_UPDATE_BASE_SITE_FAILURE, message, code })

export const loadDrives = () => ({ type: types.DOCUMENTS_LOAD_DRIVES_ATTEMPT })
export const loadDrivesSuccess = (data) => ({ type: types.DOCUMENTS_LOAD_DRIVES_SUCCESS, data })
export const loadDrivesFailure = (message, code) => ({ type: types.DOCUMENTS_LOAD_DRIVES_FAILURE, message, code })

export const loadBaseDrive = () => ({ type: types.DOCUMENTS_LOAD_BASE_DRIVE_ATTEMPT })
export const loadBaseDriveSuccess = (data) => ({ type: types.DOCUMENTS_LOAD_BASE_DRIVE_SUCCESS, data })
export const loadBaseDriveFailure = (message, code) => ({ type: types.DOCUMENTS_LOAD_BASE_DRIVE_FAILURE, message, code })

export const updateBaseDrive = (id) => ({ type: types.DOCUMENTS_UPDATE_BASE_DRIVE_ATTEMPT, id })
export const updateBaseDriveSuccess = (data) => ({ type: types.DOCUMENTS_UPDATE_BASE_DRIVE_SUCCESS, data })
export const updateBaseDriveFailure = (message, code) => ({ type: types.DOCUMENTS_UPDATE_BASE_DRIVE_FAILURE, message, code })

export const loadDocumentFoldersById = (folderId, fromRoot) => ({ type: types.DOCUMENTS_LOAD_FOLDERS_BY_ID_ATTEMPT, folderId, fromRoot })
export const loadDocumentFoldersByIdSuccess = (data) => ({ type: types.DOCUMENTS_LOAD_FOLDERS_BY_ID_SUCCESS, data })
export const loadDocumentFoldersByIdFailure = (message, code) => ({ type: types.DOCUMENTS_LOAD_FOLDERS_BY_ID_FAILURE, message, code })

export const loadIsBaseFolderSet = () => ({ type: types.DOCUMENTS_LOAD_IS_BASE_FOLDER_SET_ATTEMPT })
export const loadIsBaseFolderSetSuccess = (data) => ({ type: types.DOCUMENTS_LOAD_IS_BASE_FOLDER_SET_SUCCESS, data })
export const loadIsBaseFolderSetFailure = (message, code) => ({ type: types.DOCUMENTS_LOAD_IS_BASE_FOLDER_SET_FAILURE, message, code })

export const loadBaseFolder = () => ({ type: types.DOCUMENTS_LOAD_BASE_FOLDER_ATTEMPT })
export const loadBaseFolderSuccess = (data) => ({ type: types.DOCUMENTS_LOAD_BASE_FOLDER_SUCCESS, data })
export const loadBaseFolderFailure = (message, code) => ({ type: types.DOCUMENTS_LOAD_BASE_FOLDER_FAILURE, message, code })

export const updateDocumentBaseFolder = (id) => ({ type: types.DOCUMENTS_UPDATE_BASE_FOLDER_ATTEMPT, id })
export const updateDocumentBaseFolderSuccess = (data) => ({ type: types.DOCUMENTS_UPDATE_BASE_FOLDER_SUCCESS, data })
export const updateDocumentBaseFolderFailure = (message, code) => ({ type: types.DOCUMENTS_UPDATE_BASE_FOLDER_FAILURE, message, code })

export const loadDocumentUploadUrl = (folderPath, fileName, files, pivotTableKey) => ({ type: types.DOCUMENTS_LOAD_UPLOAD_URL_ATTEMPT, folderPath, fileName, files, pivotTableKey })
export const loadDocumentUploadUrlSuccess = (data) => ({ type: types.DOCUMENTS_LOAD_UPLOAD_URL_SUCCESS, data })
export const loadDocumentUploadUrlFailure = (message, code) => ({ type: types.DOCUMENTS_LOAD_UPLOAD_URL_FAILURE, message, code })

export const uploadFile = (uploadUrl, files, pivotTableKey) => ({ type: types.DOCUMENTS_UPLOAD_FILE_ATTEMPT, uploadUrl, files, pivotTableKey })
export const uploadFileSuccess = (data) => ({ type: types.DOCUMENTS_UPLOAD_FILE_SUCCESS, data })
export const uploadFileFailure = (message, code) => ({ type: types.DOCUMENTS_UPLOAD_FILE_FAILURE, message, code })

export const setContactsSelectedSubFolder = (path) => ({ type: types.CONTACTS_DOCUMENTS_SET_SELECTED_SUB_FOLDER, path })
export const setQuotingSelectedSubFolder = (path) => ({ type: types.QUOTING_DOCUMENTS_SET_SELECTED_SUB_FOLDER, path })
export const setJobCardDocumentsSelectedSubFolder = (path) => ({ type: types.JOB_CARD_DOCUMENTS_SET_SELECTED_SUB_FOLDER, path })
export const setPurchaseOrderSelectedSubFolder = (path) => ({ type: types.PURCHASE_ORDERS_DOCUMENTS_SET_SELECTED_SUB_FOLDER, path })
export const setDeliveriesDocumentsSelectedSubFolder = (path) => ({ type: types.DELIVERIES_DOCUMENTS_SET_SELECTED_SUB_FOLDER, path })

export const deleteDocuments = (documentIds, pivotTableKey) => ({ type: types.DOCUMENTS_DELETE_DOCUMENTS_ATTEMPT, documentIds, pivotTableKey })
